import { memo } from 'react';
import { Lightbulb } from '@/components/icons/Lightbulb';
import styles from './style/Insights.LoadingProgress.module.css';

export const LoadingProgress = memo(() => {
  return (
    <div className={styles.root}>
      <svg viewBox="0 0 100 100">
        <defs>
          <filter id="shadow">
            <feDropShadow
              dx="0"
              dy="0"
              stdDeviation="1.5"
              floodColor="#5573b1" />
          </filter>
        </defs>
        <circle
          className={styles.spinner}
          cx="50"
          cy="50"
          r="45" />
      </svg>
      <div className={styles.lightbulb}>
        <Lightbulb
          className={styles.bulb}
          size={24} />
      </div>
    </div>
  );
});

LoadingProgress.displayName = 'Insights.Panel.LoadingProgress';